import React, { useState, useEffect } from 'react'
import { NavBar } from '../../../components/NavBar/NavBar'
import { AppDispatch, RootState } from 'store'
import {
  ContentWrapper,
  Flex,
  H1WithBack,
  PageWrapper,
  Tabs,
  TabsContainer,
} from '../../../styling/GlobalStyles'
import { InventoryItemsSpecificationTab } from './InventoryItemsSpecificationTab'
import { useDispatch, useSelector } from 'react-redux'
import {
  attachMSDS,
  clearInventoryItem,
  deleteMSDS,
  getSingleInventoryItem,
  updateInventoryItem,
} from 'features/inventory/inventoryItemsSlice'
import { useNavigate, useParams } from 'react-router-dom'
import {
  clearInventoryCategory,
  getSingleInventoryCategory,
} from 'features/inventory/invSettingsCategoriesSlice'
import { InventoryItemsMachineryTab } from './InventoryItemsMachineryTab'
import { IInventoryItem } from 'types/inventory.interface'
import { isEmpty } from 'utils/helpers'
import { InventoryItemsReplenishmentTab } from './InventoryItemsReplenishmentTab'
import { InventoryItemsFinancialTab } from './InventoryItemsFinanacialTab'
import { InventoryItemsStorageTab } from './InventoryItemsStorageTab'
import { InventoryItemsTrackingTab } from './InventoryItemsTrackingTab'
import { toast } from 'react-toastify'

export const EditItem = () => {
  const [active, setActive] = useState('Specification')
  const dispatch = useDispatch<AppDispatch>()
  const { id } = useParams()
  const { singleInventoryItem } = useSelector((store: RootState) => store.inventoryItems)
  const [invalidCategoryFields, setInvalidCategoryFields] = useState<string[]>([])
  const [invalidFields, setInvalidFields] = useState([])
  const [state, setState] = useState<IInventoryItem>(null)
  const [file, setFile] = useState<File>(null)
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(getSingleInventoryItem(id))
    return () => {
      dispatch(clearInventoryItem())
    }
  }, [])

  useEffect(() => {
    state?.category && dispatch(getSingleInventoryCategory(state?.category?.value))
    return () => {
      dispatch(clearInventoryCategory())
    }
  }, [state?.category?.value])

  useEffect(() => {
    if (singleInventoryItem && !isEmpty(singleInventoryItem)) {
      const obj = structuredClone(singleInventoryItem)
      setState(obj)
    }
  }, [singleInventoryItem])


  const handleSubmit = async () => {

    if (invalidFields.length > 0 || (state.barcodes.length && state.barcodes.some(b => !b.code || !b.type?.value || !b.unit?.value || !b.quantity))) {
      toast.warn('All required fields must be valid')
      return
    }

    const resp = await dispatch(updateInventoryItem(state))
    if (resp.meta.requestStatus === 'fulfilled') {

      if (file) {

        if (state.msdsAttachmentFileUrl) {
          await dispatch(deleteMSDS(id))
        }

        const fileResp = await dispatch(attachMSDS({ file, id: resp.payload.id }))
        if (!(fileResp.meta.requestStatus === 'fulfilled')) {
          return
        }
      }
      navigate('/inventory/items')
    }
  }

  const renderTabs = () => {
    if (active === 'Specification') {
      return (
        <InventoryItemsSpecificationTab
          state={state}
          setState={setState}
          setActive={setActive}
          invalidFields={invalidFields}
          setInvalidFields={setInvalidFields}
          invalidCategoryFields={invalidCategoryFields}
          setInvalidCategoryFields={setInvalidCategoryFields}
        />
      )
    } else if (active === 'Machines') {
      return (
        <InventoryItemsMachineryTab
          state={state}
          setState={setState}
          setActive={setActive}
        />
      )
    }
    else if (active === 'Replenishment') {
      return (
        <InventoryItemsReplenishmentTab
          state={state}
          setState={setState}
          setActive={setActive}
          handleSubmit={handleSubmit}
        />
      )
    }
    else if (active === 'Financial') {
      return (
        <InventoryItemsFinancialTab
          state={state}
          setState={setState}
          setActive={setActive}
          handleSubmit={handleSubmit}
        />
      )
    }
    else if (active === 'Storage') {
      return (
        <InventoryItemsStorageTab
          file={file}
          state={state}
          setFile={setFile}
          setState={setState}
          setActive={setActive}
          handleSubmit={handleSubmit}
        />
      )
    }
    else if (active === 'Tracking') {
      return (
        <InventoryItemsTrackingTab
          state={state}
          setState={setState}
          setActive={setActive}
          handleSubmit={handleSubmit}
          invalidFields={invalidFields}
          setInvalidFields={setInvalidFields}
        />
      )
    }
  }

  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main mb='16'>
          <H1WithBack
            arrow
            title={'Edit ' + (singleInventoryItem?.name ? singleInventoryItem?.name : '')}
          />
          <TabsContainer>
            <Tabs active={active === 'Specification'} onClick={() => setActive('Specification')}>
              Specification
            </Tabs>
            <Tabs active={active === 'Replenishment'} onClick={() => setActive('Replenishment')}>
              Replenishment
            </Tabs>
            <Tabs active={active === 'Financial'} onClick={() => setActive('Financial')}>
              Financial
            </Tabs>
            <Tabs active={active === 'Storage'} onClick={() => setActive('Storage')}>
              Storage
            </Tabs>
            <Tabs active={active === 'Tracking'} onClick={() => setActive('Tracking')}>
              Tracking
            </Tabs>
            <Tabs active={active === 'Machines'} onClick={() => setActive('Machines')}>
              Machines
            </Tabs>

          </TabsContainer>
        </Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </>
  )
}
